import type { Translation } from '../../types';
import type { registry as en } from '../en/registry';

export const registry: Translation<typeof en> = {
  area: 'Vận hành Registry',
  any: 'Tất cả',
  none: 'không có',
  unlimited: 'không giới hạn',
  yes: 'Có',
  no: 'Không',
  refresh: 'Làm mới',
  resetFilters: 'Xoá bộ lọc',
  newest: 'Mới nhất',
  older: 'Cũ hơn',
  units: { ms: '{{n}} ms', s: '{{n}} giây', min: '{{n}} phút' },
  filter: {
    registry: 'Registry',
    status: 'Trạng thái',
    outcome: 'Kết quả',
    object: 'Đối tượng',
    trafficClass: 'Lớp lưu lượng',
    command: 'Lệnh',
    commandPlaceholder: 'vd. domain_renew',
    objectKey: 'Khoá đối tượng',
    objectKeyPlaceholder: 'tên / handle chính xác',
    trid: 'TRID',
    tridPlaceholder: 'clTRID hoặc svTRID',
    state: 'Tình trạng',
    type: 'Loại',
    enterHint: 'Nhấn Enter để áp dụng',
  },
  enum: {
    registryStatus: { ACTIVE: 'Hoạt động', SUSPENDED: 'Tạm ngưng', RETIRED: 'Ngừng sử dụng' },
    credentialStatus: { PENDING: 'Chờ kích hoạt', ACTIVE: 'Đang dùng', ROTATED: 'Đã xoay vòng', REVOKED: 'Đã thu hồi' },
    issueState: { OPEN: 'Mở', AUTO_RECONCILING: 'Đang tự đối soát', MANUAL_REVIEW: 'Cần xem xét thủ công', RESOLVED: 'Đã xử lý', IGNORED: 'Bỏ qua' },
    severity: { LOW: 'Thấp', MEDIUM: 'Trung bình', HIGH: 'Cao', CRITICAL: 'Nghiêm trọng' },
    commandState: {
      PENDING: 'Chờ gửi',
      SENT: 'Đã gửi',
      SUCCESS: 'Thành công',
      REJECTED: 'Bị từ chối',
      UNKNOWN: 'Chưa xác định',
      RECONCILING: 'Đang đối soát',
      RETRY_PENDING: 'Chờ thử lại',
      MANUAL_REVIEW: 'Cần xem xét thủ công',
      UNRESOLVED: 'Chưa rõ kết quả (chưa xác định / đang đối soát / xem xét thủ công)',
    },
    objectType: { DOMAIN: 'Tên miền', CONTACT: 'Liên hệ', HOST: 'Máy chủ tên', SESSION: 'Phiên', POLL: 'Thông báo poll' },
    trafficClass: { INTERACTIVE: 'Tương tác', BACKGROUND: 'Chạy nền', POLL: 'Nhận thông báo (poll)', DROPCATCH: 'Giành tên miền được giải phóng' },
    pollStatus: { UNPROCESSED: 'Chưa xử lý', UNACKED: 'Chưa xác nhận (ack)', ERROR: 'Lỗi xử lý', PROCESSED: 'Đã xử lý' },
    issueType: {
      EXISTENCE: 'Tồn tại',
      SPONSORSHIP: 'Nhà đăng ký quản lý',
      EXPIRY: 'Ngày hết hạn',
      STATUS: 'Trạng thái',
      CONTACT: 'Liên hệ',
      NAMESERVER: 'Máy chủ tên',
      DNSSEC: 'DNSSEC',
      TRANSFER: 'Chuyển nhượng',
      UNKNOWN_OUTCOME: 'Kết quả chưa xác định',
    },
    tldClass: { VN: '.vn', GTLD: 'gTLD', NEW_GTLD: 'gTLD mới', CCTLD: 'ccTLD', OTHER: 'Khác' },
    dossierType: {
      VN_DOMAIN: 'Hồ sơ tên miền .vn',
      INTERNATIONAL_GTLD: 'Hồ sơ gTLD quốc tế',
      INTERNATIONAL_NEW_GTLD: 'Hồ sơ gTLD mới quốc tế',
      INTERNATIONAL_CCTLD: 'Hồ sơ ccTLD quốc tế',
      OTHER: 'Hồ sơ khác',
    },
  },
  unknown: {
    title: 'Lệnh chưa rõ kết quả không bao giờ được gửi lại một cách tự động',
    body: 'Lệnh có kết quả chưa xác định (hết thời gian chờ sau khi gửi, mất kết nối) sẽ không được gửi lại. Quy trình đối soát hỏi lại registry xem thực tế đã xảy ra gì và ghi nhận thành công, bị từ chối hoặc tạo mục cần xem xét thủ công; việc thu phí của khách và dữ liệu công bố đi theo kết quả đó.',
    link: 'Mở trang đối soát',
  },
  tx: {
    started: 'Bắt đầu',
    registry: 'Registry',
    command: 'Lệnh',
    object: 'Đối tượng',
    state: 'Tình trạng',
    result: 'Mã kết quả',
    trids: 'clTRID / svTRID',
    classLatency: 'Lớp / độ trễ',
    corr: 'corr',
    workflow: 'workflow',
    attempt: 'lần thử #{{n}}',
    open: 'Mở lệnh {{id}}',
  },
  classTable: {
    empty: 'Chưa thiết lập lớp lưu lượng nên chỉ dùng một phiên tương tác.',
    class: 'Lớp lưu lượng',
    sessions: 'Số phiên',
    rps: 'Lệnh/giây',
    burst: 'Lệnh dồn tối đa',
  },
  registries: {
    title: 'Registry',
    subtitle: 'Các registry mà nhà đăng ký gửi lệnh tên miền tới, kèm những việc đang cần chú ý ở từng nơi.',
    loadError: 'Không tải được danh sách registry',
    empty: 'Chưa cấu hình registry nào',
    totals: 'Tất cả registry',
    openCommands: 'Lệnh đang mở',
    openCommandsHint: 'Đang xử lý hoặc chưa có kết quả',
    unknown: 'Kết quả chưa xác định',
    unknownHint: 'Đang chờ đối soát',
    drift: 'Sai lệch',
    driftHint: 'Mục đối soát đang mở',
    poll: 'Poll chưa xử lý',
    pollHint: 'Thông báo poll chưa xử lý',
    viewList: 'Xem danh sách',
    healthy: 'Ổn định',
    attention: 'Cần chú ý',
    open: 'Mở trang registry',
    adapter: 'Loại kết nối',
    tlds: 'Vùng tên miền',
    environments: 'Kết nối',
    notConfigured: 'Chưa cấu hình',
    inactive: 'không hoạt động',
    capabilities: 'Registry này cho phép những gì',
    capabilitiesVersion: 'v{{version}}, hiệu lực từ {{date}}',
    limits: 'Đăng ký tối đa {{reg}} năm, gia hạn tối đa {{renew}} năm.',
    noCapabilities: 'Chưa ghi nhận registry này cho phép những gì, nên các lệnh phụ thuộc vào điều đó sẽ bị từ chối.',
    supported: 'Hỗ trợ',
    notSupported: 'Không hỗ trợ',
    cap: {
      supports_epp: 'EPP',
      supports_contact_objects: 'Đối tượng liên hệ',
      supports_host_objects: 'Đối tượng máy chủ tên',
      supports_dnssec: 'DNSSEC',
      supports_rgp: 'Thời gian khôi phục',
      supports_fee_extension: 'Báo giá trong lệnh',
      supports_change_poll: 'Thông báo thay đổi từ registry',
      supports_idn: 'IDN',
      supports_premium: 'Tên miền premium',
      supports_transfer: 'Chuyển nhượng',
      supports_restore: 'Khôi phục',
      requires_local_presence: 'Yêu cầu hiện diện tại địa phương',
      requires_documents: 'Yêu cầu hồ sơ',
    },
  },
  registryPage: {
    tab: { overview: 'Tổng quan', connection: 'Kết nối & chứng chỉ', sessions: 'Phiên EPP', transactions: 'Giao dịch', poll: 'Poll', reconciliation: 'Đối soát', ote: 'OT&E' },
    subtitle: 'Registry này kết nối tới đâu, cho phép những gì, quản lý vùng nào và đang còn việc gì chờ xử lý.',
    loadError: 'Không tải được registry này',
    notFound: 'Không có registry với mã này',
    overview: 'Thông tin registry',
    id: 'ID',
    code: 'Mã',
    status: 'Trạng thái',
    created: 'Thêm vào',
    updated: 'Cập nhật gần nhất',
    environments: 'Cấu hình kết nối',
    noEnvironments: 'Chưa thiết lập kết nối nên không lệnh nào tới được registry này.',
    endpoint: 'Địa chỉ',
    inUse: 'Đang dùng',
    login: 'Đăng nhập',
    certificate: 'Chứng thư client',
    secretsNote: 'Ở đây chỉ cho biết đã lưu mật khẩu hay khoá riêng hay chưa — không bao giờ hiển thị giá trị.',
    passwordStored: 'Đã lưu mật khẩu',
    passwordMissing: 'Chưa lưu mật khẩu',
    keyStored: 'Đã lưu khoá riêng',
    keyMissing: 'Chưa lưu khoá riêng',
    noLogin: 'Chưa ghi nhận thông tin đăng nhập',
    noCertificate: 'Chưa ghi nhận chứng thư',
    version: 'phiên bản {{n}}',
    validity: '{{from}} → {{to}}',
    expiresSoon: 'còn {{count}} ngày',
    expired: 'Đã hết hạn',
    zones: 'Vùng tên miền do registry này quản lý',
    noZones: 'Chưa gán vùng tên miền nào cho registry này',
    recentCommands: 'Lệnh gần nhất',
    noCommands: 'Chưa gửi lệnh nào tới registry này',
    openIssues: 'Sai lệch đang mở',
    noOpenIssues: 'Không có sai lệch đang mở ở registry này',
    pollQueue: 'Hàng đợi poll',
    noPollMessages: 'Chưa nhận thông báo poll nào từ registry này',
    openEpp: 'Mở trang kết nối EPP',
  },
  catalog: {
    title: 'Danh mục TLD',
    subtitle: 'Mọi TLD trên thế giới (IANA) và vùng cấp hai đăng ký được (Public Suffix List). Bật TLD để bán, rồi đặt kênh đăng ký, giá vốn và giá bán.',
    count: '{{total}} vùng phù hợp (danh mục {{size}} vùng, phiên bản {{version}})',
    search: 'Tìm vùng',
    zone: 'Vùng',
    class: 'Phân loại',
    ianaType: 'Loại (IANA)',
    secondLevel: 'cấp hai của .{{parent}}',
    lookup: 'RDAP / WHOIS',
    state: 'Trạng thái',
    selling: 'Đang bán · {{registry}}',
    suspended: 'Đã tắt',
    off: 'Chưa bật',
    filterEnabled: 'Đang bán',
    filterDisabled: 'Chưa bật',
    empty: 'Không có vùng phù hợp.',
    enable: 'Bật TLD',
    enableTitle: 'Bật .{{zone}}',
    enableIntro: 'Phân loại {{cls}}, loại hồ sơ {{dossier}} theo danh mục.',
    registry: 'Registry / kết nối quản lý vùng',
    registryHint: 'Nơi vùng thuộc về (không dùng để tính giá).',
    choose: 'Chọn…',
    copyFrom: 'Thiết lập ban đầu',
    copyFromHint: 'Sao chép vòng đời, chuyển về / khôi phục và dịch vụ tên miền từ một TLD đang bán, hoặc dùng mặc định theo phân loại.',
    classDefaults: 'Mặc định của phân loại {{cls}}',
    copyPrices: 'Sao chép cả giá vốn và giá bán của TLD này (phiên bản mới, từ bây giờ)',
    enabled: 'Đã bật .{{zone}}.',
    reactivated: 'Đã bật lại .{{zone}}.',
    already: '.{{zone}} đã đang bán.',
    next: 'Tiếp theo: kênh đăng ký, giá vốn và giá bán.',
    disable: 'Tắt TLD',
    disableTitle: 'Tắt .{{zone}}',
    disableHint: 'Vùng ngừng bán (không báo giá, không đăng ký mới); không xoá gì, tên miền đang quản lý không đổi.',
    disabled: 'Đã tắt.',
    outsideTitle: 'Vùng đang bật ngoài danh mục',
    outsideHint: 'Bật trước khi có danh mục hoặc do dữ liệu thử nghiệm (ví dụ .example, .test). Không bật lại được ở đây, chỉ ngừng bán.',
    stopSelling: 'Ngừng bán',
    stopSellingTitle: 'Ngừng bán .{{zone}}',
    stopped: 'Đã ngừng bán.',
    previous: 'Trang trước',
    nextPage: 'Trang sau',
  },
  tlds: {
    title: 'Vùng tên miền',
    subtitle: 'Các vùng khách hàng có thể đăng ký, quy định áp dụng và số tên miền nhà đăng ký đang quản lý.',
    loadError: 'Không tải được danh sách vùng tên miền',
    empty: 'Không có vùng tên miền phù hợp',
    zone: 'Vùng',
    registry: 'Registry',
    class: 'Phân loại',
    dossier: 'Loại hồ sơ',
    icann: 'ICANN',
    governed: 'Chịu quản lý',
    rdapWhois: 'RDAP / WHOIS',
    metricGroup: 'Nhóm báo cáo',
    status: 'Trạng thái',
    managed: 'Tên miền đang quản lý',
    on: 'bật',
    off: 'tắt',
    open: 'Mở vùng {{zone}}',
  },
  problem: {
    reason: {
      REGISTRY_NOT_CONFIGURED: 'Kết nối registry của TLD này chưa dùng được',
      REGISTRY_AUTH_FAILED: 'Nhà đăng ký từ chối đăng nhập',
      REGISTRY_ERROR: 'Nhà đăng ký báo lỗi',
      REGISTRY_TIMEOUT: 'Nhà đăng ký không trả lời kịp',
      TLD_NOT_OFFERED_BY_REGISTRY: 'Nhà đăng ký không cung cấp đuôi tên miền này',
      other: 'Chưa hỏi được nhà đăng ký',
    },
    missing: {
      CONNECTION_UNKNOWN: 'Kết nối không còn tồn tại',
      CONNECTION_INACTIVE: 'Kết nối đang tạm ngừng',
      CONNECTION_DISABLED: 'Chưa bật cấu hình kết nối',
      ENDPOINT_MISSING: 'Chưa có địa chỉ máy chủ',
      SETTINGS_INVALID: 'Cấu hình chưa hợp lệ',
      CREDENTIAL_MISSING: 'Chưa có thông tin đăng nhập',
      CERTIFICATE_MISSING: 'Chưa có chứng chỉ máy khách',
      CERTIFICATE_INVALID: 'Chứng chỉ không dùng được',
      CAPABILITIES_MISSING: 'Chưa ghi nhận quy định của nhà quản lý',
      ADAPTER_UNAVAILABLE: 'Chưa hỗ trợ kết nối này',
      SECRET_UNAVAILABLE: 'Không đọc được mật khẩu đã lưu',
      WRONG_CREDENTIALS: 'Sai tên đăng nhập / mật khẩu API',
      IP_NOT_ALLOWED: 'IP máy chủ chưa được cho phép',
      CREDENTIALS_REJECTED: 'Bị từ chối: sai thông tin đăng nhập hoặc IP chưa được cho phép',
      API_REJECTED: 'Đăng nhập được nhưng lệnh đọc bị từ chối',
      ADDRESS_NOT_ALLOWED: 'Địa chỉ máy chủ của nhà đăng ký không được phép gọi tới',
      API_TIMEOUT: 'Nhà đăng ký không trả lời kịp',
      API_UNREACHABLE: 'Không kết nối được tới nhà đăng ký',
      API_UNEXPECTED_RESPONSE: 'Trả lời không đọc được',
      CONFIGURATION_INVALID: 'Cấu hình chưa hợp lệ',
    },
    provider: 'Trả lời của nhà đăng ký: {{code}} {{message}}',
    openConnection: 'Mở kết nối {{name}}',
    openTld: 'Mở trang TLD',
    hintAuth: 'Kiểm tra tên đăng nhập / mật khẩu API của đúng môi trường (OT&E hay chính thức) và thêm địa chỉ IP của máy chủ này vào danh sách IP được phép ở cổng quản trị của nhà đăng ký.',
  },
  publication: {
    US: 'Tino công bố',
    UPSTREAM: 'Do {{name}} công bố',
    REGISTRY: 'Do nhà quản lý tên miền công bố',
    PARTIAL: 'Chỉ bật một phần',
    OFF: 'Chưa bật',
    hint: {
      US: 'RDAP / WHOIS của các tên miền trong vùng này do máy chủ của Tino trả lời.',
      UPSTREAM: 'Tên miền đăng ký qua {{name}}: {{name}} là nhà đăng ký của tên miền nên {{name}} (và registry) công bố RDAP / WHOIS, không phải Tino.',
      REGISTRY: 'Nhà quản lý tên miền công bố dữ liệu đăng ký của vùng này.',
      PARTIAL: 'Tino chỉ công bố một trong hai (RDAP hoặc WHOIS) cho vùng này.',
      OFF: 'Tino chưa công bố RDAP / WHOIS cho vùng này.',
    },
  },
  readiness: {
    costNotChannel: 'Giá vốn này được đặt trước khi đổi kênh đăng ký sang {{name}}: đó là giá của kênh cũ. Nhập giá vốn theo bảng giá của {{name}}.',
    title: 'Sẵn sàng bán',
    ready: 'Sẵn sàng bán',
    notReady: 'Chưa bán được',
    missingList: 'Thiếu: {{list}}',
    warnList: 'Nên xem: {{list}}',
    intro: 'Những gì .{{zone}} cần để khách hàng đăng ký được. Mục chưa đạt có nút sửa hoặc đường dẫn tới nơi sửa.',
    state: { OK: 'Đạt', MISSING: 'Còn thiếu', WARN: 'Nên xem lại', UNKNOWN: 'Chưa kiểm tra' },
    item: {
      CONNECTION: 'Kết nối đang dùng được',
      LOGIN_TEST: 'Đã thử đăng nhập vào nhà đăng ký',
      REGISTRY_COST: 'Giá vốn (đăng ký, gia hạn, khôi phục, chuyển về)',
      SALE_PRICE: 'Giá bán cho khách lẻ (bậc mặc định)',
      FX_RATE: 'Tỷ giá quy đổi',
      ADDONS: 'Phí & dịch vụ kèm theo',
      PUBLICATION: 'RDAP / WHOIS',
      AVAILABILITY: 'Kiểm tra tên miền còn trống',
    },
    short: {
      CONNECTION: 'kết nối',
      LOGIN_TEST: 'thử đăng nhập',
      REGISTRY_COST: 'giá vốn',
      SALE_PRICE: 'giá bán',
      FX_RATE: 'tỷ giá',
      ADDONS: 'dịch vụ kèm theo',
      PUBLICATION: 'RDAP / WHOIS',
      AVAILABILITY: 'kiểm tra tên',
    },
    connectionOk: 'Qua {{name}} ({{source}}).',
    source: { CONFIGURED: 'kênh riêng của TLD', DEFAULT: 'theo mặc định' },
    loginNever: 'Chưa kiểm tra đăng nhập kết nối {{name}}.',
    loginOk: 'Lần thử gần nhất thành công {{when}}.',
    loginFailed: 'Lần thử gần nhất thất bại {{when}}.',
    costsMissingOps: 'Chưa có giá vốn: {{ops}}.',
    noCost: 'Chưa có giá vốn đăng ký.',
    noBook: 'Chưa có bảng giá bán lẻ cho bậc mặc định.',
    saleMissing: 'Bảng giá {{books}} chưa có giá bán đăng ký cho TLD này.',
    renewMissing: 'Chưa có giá bán gia hạn.',
    saleOk: 'Có giá bán trong {{books}}.',
    fxMissing: 'Chưa có tỷ giá {{pairs}}.',
    addonsNotDecided: 'Chưa chọn dịch vụ kèm theo. Mặc định cho loại TLD này: {{list}}.',
    addonsUnpriced: 'Dịch vụ bắt buộc chưa có giá: {{list}}.',
    addonsIncluded: '{{list}} đã gồm trong giá của nhà đăng ký trung gian nên không được tính khi đăng ký qua kênh này; nên tắt để bảng giá khớp với báo giá.',
    addonsOk: '{{count}} dịch vụ đang cung cấp.',
    addonsNone: 'Loại TLD này không có dịch vụ mặc định.',
    availabilityHint: 'Hỏi nhà đăng ký một tên thật để chắc chắn kết nối, đăng nhập và TLD đều dùng được.',
    fix: {
      OPEN_CONNECTION: 'Mở kết nối',
      OPEN_PRICING: 'Mở giá & dịch vụ',
      SET_SALE_PRICE: 'Đặt giá bán',
      APPLY_DEFAULT_ADDONS: 'Bật các dịch vụ mặc định',
      ENABLE_PUBLICATION: 'Bật RDAP / WHOIS',
      TEST_CHECK: 'Thử kiểm tra một tên',
    },
    reasonDefaults: 'Bật các dịch vụ mặc định từ danh sách kiểm tra TLD',
    reasonPublication: 'Bật RDAP / WHOIS từ danh sách kiểm tra TLD',
    reasonSale: 'Đặt giá bán từ danh sách kiểm tra TLD',
    saleTitle: 'Đặt giá bán cho .{{zone}}',
    margin: 'Lãi % trên giá vốn',
    fixed: 'Giá cố định mỗi năm',
    value: 'Giá trị',
    books: 'Áp dụng cho: {{books}}',
    testName: 'Tên cần kiểm tra',
    testPlaceholder: 'để trống: một tên ngẫu nhiên',
    test: 'Kiểm tra',
    testAvailable: '{{name}} còn trống: kết nối, đăng nhập và TLD đều dùng được.',
    testTaken: '{{name}} đã có người đăng ký (nhà đăng ký trả lời bình thường).',
  },
  setup: {
    button: 'Thêm TLD',
    title: 'Thêm TLD để bán',
    description: 'Chọn kết nối, TLD, giá vốn và giá bán. Dịch vụ kèm theo và RDAP / WHOIS được đặt theo loại TLD.',
    connection: 'Kết nối đăng ký',
    connectionHint: 'Kết nối này nhận đăng ký mới và chuyển về của TLD.',
    choose: 'Chọn…',
    zone: 'TLD',
    zoneSearch: 'Tìm đuôi tên miền',
    fromConnection: 'Danh sách đuôi tên miền {{name}} cung cấp.',
    fromCatalog: 'Danh mục TLD (chưa lấy được danh sách của kết nối).',
    selling: 'đang bán',
    noZone: 'Không có TLD phù hợp.',
    cost: 'Giá vốn mỗi năm',
    costHint: 'Một giá cho cả đăng ký, gia hạn, khôi phục và chuyển về. Sửa riêng từng thao tác nếu khác.',
    currency: 'Tiền tệ',
    perOperation: 'Sửa riêng từng thao tác',
    op: { REGISTER: 'Đăng ký', RENEW: 'Gia hạn', RESTORE: 'Khôi phục', TRANSFER: 'Chuyển về' },
    sale: 'Giá bán',
    saleHint: 'Áp dụng cho bảng giá bán lẻ bậc mặc định: {{books}}.',
    noBooks: 'Chưa có bảng giá bán lẻ cho bậc mặc định: tạo ở Sản phẩm & giá trước.',
    margin: 'Lãi % trên giá vốn',
    fixed: 'Giá cố định mỗi năm ({{currency}})',
    addons: 'Dịch vụ kèm theo (bật tự động)',
    addonsNone: 'Loại TLD này không có dịch vụ mặc định.',
    addonCost: 'Giá vốn {{name}} mỗi năm',
    mode: { MANDATORY: 'bắt buộc', DEFAULT: 'bật sẵn', OPTIONAL: 'tuỳ chọn' },
    leftOut: 'Phí ICANN không được thêm: giá của {{name}} đã gồm phí này.',
    publication: 'RDAP / WHOIS',
    summary: '.{{zone}} qua {{connection}}; giá vốn {{cost}} {{currency}}; giá bán {{sale}}.',
    summaryMargin: 'lãi {{value}}%',
    summaryFixed: '{{value}} {{currency}} mỗi năm',
    create: 'Tạo TLD',
    created: 'Đã thêm .{{zone}}.',
    openTld: 'Mở trang .{{zone}}',
  },
  tldPage: {
    tab: { info: 'Thông tin', channels: 'Kênh đăng ký', lifecycle: 'Vòng đời & chuyển / khôi phục', pricing: 'Giá & dịch vụ', services: 'Dịch vụ', policies: 'Chính sách' },
    subtitle: 'Quy định áp dụng cho vùng này và các tên miền nhà đăng ký đang quản lý trong vùng.',
    loadError: 'Không tải được vùng tên miền này',
    notFound: 'Không có vùng tên miền tương ứng',
    rules: 'Quy định của vùng',
    id: 'ID',
    prices: 'Mở bảng giá',
    domains: 'Tên miền đang quản lý',
    channel: 'Kênh đăng ký (chính thức)',
    costs: 'Giá vốn đang áp dụng',
    noCost: 'Chưa có giá vốn',
    op: { REGISTER: 'Đăng ký', RENEW: 'Gia hạn' },
    addons: 'Dịch vụ đang cung cấp',
    addonsMandatory: '{{count}} dịch vụ bắt buộc',
    addonsMissing: '{{count}} dịch vụ bắt buộc chưa có giá',
    byState: 'Tên miền theo tình trạng',
    noByState: 'Chưa có tên miền nào trong vùng này',
    recent: 'Đăng ký mới nhất',
    noRecent: 'Chưa có tên miền nào được đăng ký trong vùng này',
    domain: 'Tên miền',
    state: 'Tình trạng',
    registered: 'Đăng ký tại registry',
    expires: 'Hết hạn tại registry',
    added: 'Thêm vào hệ thống',
  },
  epp: {
    title: 'Kết nối EPP',
    subtitle: 'Cách nhà đăng ký kết nối tới từng registry: địa chỉ kết nối, số lệnh được gửi cùng lúc, và thông tin đăng nhập cùng chứng thư đã sẵn sàng hay chưa.',
    secretsTitle: 'Không bao giờ hiển thị mật khẩu và khoá riêng',
    secrets:
      'Trang này chỉ cho biết đã lưu mật khẩu hay khoá riêng hay chưa. Vị trí lưu bí mật và tên đăng nhập EPP chỉ hiển thị cho nhân viên được phép quản lý thông tin đăng nhập registry; không ai xem được giá trị. Không thể thay đổi gì ở trang này.',
    loadError: 'Không tải được kết nối EPP',
    empty: 'Chưa thiết lập kết nối registry nào',
    active: 'Đang hoạt động',
    inactive: 'Không hoạt động',
    noHost: 'chưa có địa chỉ',
    settingsError: 'Không đọc được thiết lập của kết nối này nên nhà đăng ký không thể mở kết nối tới đó. Cần chỉnh lại thiết lập.',
    connection: 'Kết nối',
    tls: 'TLS',
    tlsOn: 'bật',
    sni: 'SNI',
    plainTcp: 'TCP thường',
    privateCa: 'CA riêng',
    systemRoots: 'CA công khai',
    connectTimeout: 'Thời gian chờ kết nối',
    commandTimeout: 'Thời gian chờ lệnh',
    acquireTimeout: 'Chờ có phiên trống',
    breaker: 'Ngắt khi lỗi liên tiếp',
    breakerValue: 'sau {{n}} lỗi, trong {{duration}}',
    maxCommands: 'Số lệnh mỗi phiên',
    maxIdle: 'Rảnh bao lâu thì kết nối lại',
    maxLifetime: 'Vòng đời phiên',
    pools: 'Hạn mức phiên theo lớp lưu lượng',
    credentials: 'Thông tin đăng nhập',
    noCredentials: 'Chưa lưu thông tin đăng nhập nên nhà đăng ký không thể đăng nhập vào registry này.',
    noActiveCredential: 'Không có phiên bản đăng nhập nào đang được dùng.',
    version: 'Phiên bản',
    status: 'Trạng thái',
    clientId: 'Tên đăng nhập',
    hidden: 'ẩn',
    password: 'Mật khẩu',
    activated: 'Dùng từ',
    retired: 'Ngừng dùng',
    certificates: 'Chứng thư client',
    noCertificates: 'Chưa ghi nhận chứng thư client nào.',
    noActiveCertificate: 'Không có phiên bản chứng thư nào đang được dùng.',
    valid: 'Hiệu lực',
    privateKey: 'Khoá riêng',
    expired: 'Đã hết hạn',
    daysLeft_one: 'còn {{count}} ngày',
    daysLeft_other: 'còn {{count}} ngày',
    configured: 'Đã lưu',
    notConfigured: 'Chưa lưu',
    openRegistry: 'Mở trang registry',
  },
  sessions: {
    title: 'Phiên EPP',
    subtitle: 'Mỗi registry cho phép bao nhiêu phiên EPP theo từng lớp lưu lượng, các lệnh đã gửi trong những giờ gần đây và các lệnh phiên.',
    limitTitle: 'Không xem được phiên đang chạy tại đây',
    limit:
      'Kết nối đang mở và phiên đã đăng nhập chỉ tồn tại trong lúc hệ thống đang chạy và không được lưu lại, nên không thể hiển thị ở đây. Phần bên dưới là những gì đã lưu: hạn mức phiên theo lớp lưu lượng, các lệnh trong những giờ gần nhất và các lệnh phiên.',
    limitLink: 'Xem kết nối, độ trễ và tỷ lệ lỗi trực tiếp tại Sức khoẻ registry',
    loadError: 'Không tải được dữ liệu phiên',
    pools: 'Hạn mức phiên theo kết nối',
    noPools: 'Chưa thiết lập kết nối registry nào',
    recycle: 'Phiên được làm mới sau {{commands}} lệnh, {{idle}} không dùng hoặc {{lifetime}} hoạt động. Chờ phiên trống quá {{acquire}} sẽ dừng.',
    noRecycle: 'Phiên được giữ mở, không giới hạn số lệnh hay thời gian. Chờ phiên trống quá {{acquire}} sẽ dừng.',
    traffic: 'Lệnh trong {{hours}} giờ qua theo lớp lưu lượng',
    noTraffic: 'Không có lệnh nào được gửi trong khoảng thời gian này',
    registry: 'Registry',
    class: 'Lớp lưu lượng',
    total: 'Tổng',
    success: 'Thành công',
    rejected: 'Bị từ chối',
    unknown: 'Chưa xác định',
    inFlight: 'Đang xử lý',
    maxLatency: 'Chậm nhất',
    last: 'Lệnh gần nhất',
    sessionCommands: 'Lệnh phiên (login / logout / hello)',
    noSessionTx: 'Chưa ghi nhận lệnh phiên nào',
    noSessionTxBody: 'Hiện việc đăng nhập, đăng xuất và kiểm tra kết nối không được ghi nhận thành lệnh registry.',
  },
  transactions: {
    title: 'Lệnh gửi registry',
    subtitle: 'Mọi lệnh nhà đăng ký đã gửi tới registry, kèm clTRID / svTRID và kết quả, mới nhất trước.',
    loadError: 'Không tải được danh sách lệnh',
    empty: 'Không có lệnh phù hợp',
    onlyUnknown: 'Chỉ kết quả chưa xác định',
    listTitle: 'Lệnh',
    count: '{{count}} lệnh trên trang này',
  },
  poll: {
    title: 'Thông báo poll',
    subtitle: 'Thông báo các registry gửi cho nhà đăng ký — chuyển nhượng, gia hạn, đổi trạng thái — và từng thông báo đã được xử lý hay chưa.',
    loadError: 'Không tải được thông báo poll',
    empty: 'Không có thông báo poll phù hợp',
    queue: 'Hàng đợi theo registry',
    registry: 'Registry',
    receivedCount: 'Đã nhận',
    unprocessed: 'Chưa xử lý',
    unacked: 'Chưa xác nhận (ack)',
    errors: 'Lỗi',
    oldest: 'Cũ nhất chưa xử lý',
    lastReceived: 'Nhận gần nhất',
    messages: 'Thông báo',
    received: 'Nhận lúc',
    messageId: 'Số thông báo',
    message: 'Nội dung',
    object: 'Đối tượng',
    queuedAt: 'Registry phát sinh lúc',
    acked: 'Đã xác nhận (ack)',
    processed: 'Đã xử lý',
    no: 'Chưa',
    error: 'Lỗi',
    pending: 'Đang chờ',
    open: 'Mở thông báo',
    openOne: 'Mở thông báo {{id}}',
    openRegistry: 'Mở trang registry',
  },
  pollMessage: {
    title: 'Thông báo poll',
    subtitle: 'Một thông báo registry gửi cho nhà đăng ký và các đối tượng liên quan.',
    loadError: 'Không tải được thông báo này',
    notFound: 'Không có thông báo poll tương ứng',
    details: 'Thông báo',
    id: 'ID',
    content: 'Nội dung thông báo',
    contentNote: 'Những giá trị có thể để lộ bí mật đã được loại bỏ trước khi hiển thị, và việc mở nội dung này được ghi nhận lại.',
    contentWithheld: 'Bạn không được xem nội dung đã lưu. Hãy nhờ đồng nghiệp được phép mở nội dung gửi nhận với registry.',
    linked: 'Thông báo này liên quan tới',
    objectName: 'Đối tượng tại registry',
    processingError: 'Vì sao chưa xử lý được',
    handled: 'Đã xử lý',
    notHandled: 'Chưa xử lý',
  },
  reconciliation: {
    title: 'Đối soát',
    subtitle: 'Các lệnh registry chưa xác nhận kết quả và những chỗ dữ liệu nội bộ khác với registry.',
    loadError: 'Không tải được hàng đợi đối soát',
    unknownTitle: 'Lệnh có kết quả chưa xác định',
    unknownDesc: '{{count}} lệnh, cũ nhất trước',
    noUnknown: 'Không có kết quả chưa xác định',
    issuesTitle: 'Sai lệch đang chờ xử lý',
    issuesDesc: '{{count}} mục',
    anyOpen: 'Đang mở (mọi trạng thái mở)',
    noIssues: 'Không có mục phù hợp',
    detected: 'Phát hiện',
    registry: 'Registry',
    domain: 'Tên miền',
    type: 'Loại',
    severity: 'Mức độ',
    state: 'Tình trạng',
    transaction: 'Lệnh',
    command: 'lệnh',
    resolution: 'Cách xử lý',
    local: 'Dữ liệu nội bộ',
    remote: 'Registry',
    withheld: '{{label}}: không hiển thị',
    noValue: '{{label}}: không có',
    unknownActor: 'không rõ',
    open: 'Mở mục',
    openOne: 'Mở mục {{type}}',
  },
  issue: {
    subtitle: 'Dữ liệu nội bộ, dữ liệu tại registry và những gì đã xử lý.',
    loadError: 'Không tải được mục này',
    notFound: 'Không có mục đối soát tương ứng',
    summary: 'Mục đối soát',
    id: 'ID',
    compare: 'So sánh dữ liệu nội bộ với registry',
    compareNote: 'Cả hai bên đều đã được loại bỏ dữ liệu cá nhân và bí mật.',
    command: 'Lệnh dẫn tới sai lệch',
    noCommand: 'Chưa truy được sai lệch này về lệnh nào',
    openCommand: 'Mở lệnh',
    started: 'Bắt đầu',
    completed: 'Hoàn tất',
    result: 'Mã kết quả',
    errorClass: 'Loại lỗi',
    trids: 'clTRID / svTRID',
    resolvedAt: 'Đã xử lý',
    resolvedBy: 'Người xử lý',
    history: 'Các sai lệch khác của tên miền này',
    noHistory: 'Chưa ghi nhận sai lệch nào khác cho tên miền này',
    commands: 'Lệnh gần đây của tên miền này',
    noCommands: 'Chưa ghi nhận lệnh nào cho tên miền này',
  },
  hub: {
    links: 'Trang liên quan',
    link: { pricing: 'Bảng giá', promotions: 'Khuyến mãi', services: 'Add-on & phí', quote: 'Tính thử báo giá', catalog: 'Danh mục TLD', channels: 'Registrar & định tuyến' },
    book: 'Bảng giá',
    bookNote: 'Giá bán hạng {{tier}} · {{currency}} · một năm, chưa thuế',
    bookNoteOther: '{{currency}} · một năm, chưa thuế',
    noBook: 'Chưa có bảng giá đang dùng: tạo ở Bảng giá.',
    pricesHidden: 'Không hiện giá: cần quyền xem bảng giá.',
    search: 'Tìm',
    searchPlaceholder: 'TLD hoặc kết nối',
    group: 'Nhóm TLD',
    col: { tld: 'TLD', connection: 'Kết nối đăng ký', register: 'Đăng ký', renew: 'Gia hạn', transfer: 'Chuyển về', restore: 'Khôi phục', effective: 'Hiệu lực', ready: 'Sẵn sàng bán', state: 'Tình trạng bán' },
    catalog: {
      size: 'Vùng trong danh mục',
      sizeHint: 'Danh mục phiên bản {{version}}',
      selling: 'Đang bán',
      sellingHint: 'Bật ở đây hoặc qua “Thêm TLD”',
      sellingLink: 'Mở TLD & bảng giá',
      matches: 'Phù hợp bộ lọc',
      matchesHint: 'Tìm, nhóm và trạng thái phía trên danh sách',
    },
    step: { connection: 'Kết nối', zone: 'TLD', cost: 'Giá vốn', sale: 'Giá bán', addons: 'Dịch vụ', create: 'Tạo' },
    readinessProgress: 'Mục đã đạt',
    missingShort: 'Chưa có',
    effectiveNow: 'Đang áp dụng',
    effectiveFrom: 'Giá mới từ {{date}}',
    noCost: 'Chưa có giá vốn',
    noRule: 'Chưa có giá',
    notOffered: 'Không bán',
    free: 'Miễn phí',
    shown: '{{shown}} / {{total}} TLD',
    selectRow: 'Xem hồ sơ .{{zone}}',
    model: {
      title: 'Cách tính giá bán',
      description: 'Giá khách trả được chốt vào báo giá và dòng đơn hàng; đổi bảng giá sau đó không làm đổi giá đã chốt.',
      cost: 'Giá vốn',
      costHint: 'Nhà quản lý / nhà đăng ký trung gian',
      margin: 'Biên lợi nhuận',
      marginHint: 'Riêng từng TLD hoặc chung cả bảng giá',
      sale: 'Giá bán',
      saleHint: 'Bảng giá theo hạng / giá riêng khách hàng',
      quote: 'Giá chốt',
      quoteHint: 'Trên báo giá và đơn hàng',
      premium: 'Tên miền premium',
      premiumHint: 'Giá nhà quản lý báo thay cho giá vốn; chỉ cộng biên lợi nhuận, báo giá hết hạn sớm hơn',
      promotions: 'Khuyến mãi',
      promotionsHint: 'Mã giảm giá theo TLD và thao tác',
      fx: 'Tỷ giá',
      fxHint: 'Giá vốn ngoại tệ đổi theo tỷ giá đang áp dụng',
      tax: 'Thuế',
      taxHint: 'VAT theo từng khoản',
      addons: 'Phí & dịch vụ kèm theo',
      addonsHint: 'Phí bắt buộc và dịch vụ tuỳ chọn theo TLD',
    },
    profile: {
      title: 'Hồ sơ TLD · .{{zone}}',
      description: 'Quy định và kênh đăng ký của TLD đang chọn',
      none: 'Chọn một TLD trong danh sách.',
      open: 'Mở trang TLD',
      prices: 'Giá & dịch vụ',
      channel: 'Kênh đăng ký',
      costRegister: 'Giá vốn đăng ký',
    },
    versions: {
      title: 'Phiên bản giá · {{book}}',
      description: 'Giá bán .{{zone}} trong bảng giá này theo thời gian',
      op: '{{op}} · phiên bản {{version}}',
      shared: '{{op}} · giá chung của bảng giá, phiên bản {{version}}',
      active: 'Đang áp dụng',
      scheduled: 'Chờ hiệu lực',
      ended: 'Đã thay',
      window: 'Từ {{from}}',
      windowTo: 'Từ {{from}} đến {{to}}',
      empty: 'Chưa có giá bán nào cho .{{zone}} trong bảng giá này.',
      approval: 'Giá bán áp dụng theo thời điểm hiệu lực, không cần người thứ hai duyệt; mọi lần đổi đều được ghi nhật ký.',
    },
  },
};
